import { render, staticRenderFns } from "./ResumenSimpatizanteSgaComponent.vue?vue&type=template&id=8f1dae52"
import script from "./ResumenSimpatizanteSgaComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumenSimpatizanteSgaComponent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports